import React, { useState, useEffect } from 'react';
import { KTSVG } from '../../../../_mexablock/helpers';
import { useFormik } from 'formik';
import { NumericFormat } from 'react-number-format';
import Select from 'react-select';
import {
  useSelectDegree,
  useSelectInstitutions,
} from '../../catalogos/generico/hooks/genericoHook';

type Props = {
  initFilterValues: any;
  onCleanFilter: () => void;
  onSearchFilter: (values: any) => void;
};

type SelectOptions = {
  value: number;
  label: string;
};

const Filter: React.FC<Props> = ({
  initFilterValues,
  onSearchFilter,
  onCleanFilter,
}) => {
  const [filterValues, setFilterValues] = useState(initFilterValues);
  const [selectedDegree, setSelectedDegree] = useState<SelectOptions | null>(
    null
  );
  const [selectedInstitution, setSelectedInstition] =
    useState<SelectOptions | null>(null);
  const { data: degree } = useSelectDegree(true);
  const { data: institutions } = useSelectInstitutions(
    selectedDegree?.value || 0
  );
  useEffect(() => {
    if (initFilterValues) {
      setFilterValues(initFilterValues);
    }
  }, [initFilterValues]);

  const formFilter = useFormik({
    initialValues: filterValues,
    enableReinitialize: true,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      onSearchFilter(values);
    },
  });

  const handleDegree = (selectedOption: any) => {
    const id = selectedOption.value;
    setSelectedDegree(selectedOption);
    formFilter.setFieldValue('education_degree', id);
  };

  const handleInstitution = (selectedOption: any) => {
    const id = selectedOption.value;
    setSelectedInstition(selectedOption);
    formFilter.setFieldValue('institution_id', id);
  };

  const handleChangeInput = (
    event: React.ChangeEvent<HTMLInputElement>,
    key: string
  ) => {
    const value = event.target.value;
    const valueReg = value.replace(/\d/g, '');
    const cleanInput = valueReg.replace(/^\s+|\s+(?=\s)/g, '');
    const inputLimpio = cleanInput.replace(/[^\wáéíóúüÁÉÍÓÚÜñÑ\s]/g, '');
    formFilter.setFieldValue(key, inputLimpio);
  };

  return (
    <>
      <div className="card-title align-items-start flex-column">
        <a
          href="#/"
          className={
            formFilter.values.verified_email !== 0
              ? 'btn btn-sm btn-primary'
              : 'btn btn-sm btn-light-primary'
          }
          data-kt-menu-trigger="click"
          data-kt-menu-placement="right-start"
        >
          <KTSVG
            path="/media/icons/duotune/general/gen031.svg"
            className="svg-icon-5 svg-icon-gray-500 me-1"
          />
          Filtrar
        </a>
        <div
          className="menu menu-sub menu-sub-dropdown w-250px w-md-300px ms-2"
          data-kt-menu="true"
        >
          <div className="px-7 py-5">
            <div className="fs-5 text-dark fw-bolder">Opciones de filtro</div>
          </div>
          <div className="separator border-gray-200"></div>
          <form
            id="kt_modal_generic_form"
            className="form"
            action="#"
            onSubmit={formFilter.handleSubmit}
          >
            <div className="px-7 py-5">
              <div className="mb-5">
                <label className="fs-6 fw-semibold form-label mb-2">
                  Nombre
                </label>
                <input
                  {...formFilter.getFieldProps('nombre')}
                  className="form-control mb-3"
                  type="text"
                  name="nombre"
                  maxLength={20}
                  autoComplete="off"
                  onChange={(e: any) => {
                    handleChangeInput(e, 'nombre');
                  }}
                />
              </div>
              <div className="mb-5">
                <label className=" fw-bold fs-6 mb-2 w-auto">ICCID</label>
                <NumericFormat
                  name="iccid"
                  className="form-control text-gray-700 placeholder-gray-400 mw-500px"
                  value={formFilter.values.iccid}
                  decimalScale={0}
                  decimalSeparator="."
                  maxLength={19}
                  fixedDecimalScale
                  prefix=""
                  thousandSeparator=""
                  onValueChange={(values) => {
                    const { value } = values;
                    formFilter.setFieldValue('iccid', value ? value : '');
                  }}
                />
              </div>
              <div className="mb-5">
                <label className=" fw-bold fs-6 mb-2 ">Número</label>
                <NumericFormat
                  name="msisdn"
                  className="form-control text-gray-700 placeholder-gray-400 mw-500px"
                  value={formFilter.values.msisdn}
                  decimalScale={0}
                  decimalSeparator="."
                  maxLength={10}
                  fixedDecimalScale
                  prefix=""
                  thousandSeparator=""
                  onValueChange={(values) => {
                    const { value } = values;
                    formFilter.setFieldValue('msisdn', value ? value : '');
                  }}
                />
              </div>
              <div className="mb-5">
                <label className=" fs-6 fw-semibold form-label mb-2">
                  Grado de estudios
                </label>
                <div onClick={(e) => e.stopPropagation()}>
                  <Select
                    options={degree}
                    placeholder={'Seleccione'}
                    onChange={handleDegree}
                    value={selectedDegree}
                    className="mb-3"
                    noOptionsMessage={() => {
                      return <span>No hay registros</span>;
                    }}
                    styles={{
                      placeholder: (provided, state) => ({
                        ...provided,
                        color: '#181c32',
                      }),
                      indicatorSeparator: (provided, state) => ({
                        ...provided,
                        display: 'none',
                      }),
                      dropdownIndicator: (provided, state) => ({
                        ...provided,
                        color: '#7E8199',
                      }),
                      control: (provided, state) => ({
                        ...provided,
                        border: '1px solid #e4e6ef',
                        borderRadius: '6px',
                        padding: '3px',
                        fontSize: '1.1rem',
                        boxShadow: 'none',
                        backgroundColor: state.isDisabled ? '#EFF2F5' : 'white',
                      }),
                      option: (provided, state) => ({
                        ...provided,
                        fontSize: '1.1rem',
                      }),
                    }}
                  />
                </div>
              </div>
              <div className="mb-5">
                <label className=" fs-6 fw-semibold form-label mb-2">
                  Institución
                </label>
                <div onClick={(e) => e.stopPropagation()}>
                  <Select
                    options={institutions}
                    placeholder={'Seleccione'}
                    onChange={handleInstitution}
                    value={selectedInstitution}
                    className="mb-3"
                    noOptionsMessage={() => {
                      return <span>No hay registros</span>;
                    }}
                    styles={{
                      placeholder: (provided, state) => ({
                        ...provided,
                        color: '#181c32',
                      }),
                      indicatorSeparator: (provided, state) => ({
                        ...provided,
                        display: 'none',
                      }),
                      dropdownIndicator: (provided, state) => ({
                        ...provided,
                        color: '#7E8199',
                      }),
                      control: (provided, state) => ({
                        ...provided,
                        border: '1px solid #e4e6ef',
                        borderRadius: '6px',
                        padding: '3px',
                        fontSize: '1.1rem',
                        boxShadow: 'none',
                        backgroundColor: state.isDisabled ? '#EFF2F5' : 'white',
                      }),
                      option: (provided, state) => ({
                        ...provided,
                        fontSize: '1.1rem',
                      }),
                    }}
                  />
                </div>
              </div>
              <div className="d-flex justify-content-end">
                <button
                  type="reset"
                  className="btn btn-sm btn-white btn-active-light-primary me-2"
                  data-kt-menu-dismiss="true"
                  onClick={() => {
                    formFilter.resetForm();
                    setSelectedDegree(null);
                    setSelectedInstition(null);
                    onCleanFilter();
                  }}
                >
                  Limpiar
                </button>

                <button
                  type="submit"
                  className="btn btn-sm btn-primary"
                  data-kt-menu-dismiss="true"
                >
                  Buscar
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export { Filter };
